import React from 'react';
import { camelToTitle } from './utils';

export const injectPropsChildren = (
  children: React.ReactNode,
  props: Record<string, any>
): React.ReactNode =>
  React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ...props,
      });
    }
    return child;
  });

export const toCsv = (data: Record<string, any>[]): string => {
  if (!data || !data.length) {
    throw new Error('Requires an Array');
  }
  const keys = Object.keys(data[0]);
  const titles = keys.map((i) => camelToTitle(i));
  let csv = titles.join(',');
  csv += '\n';
  return data.reduce((acc, curr) => {
    const values = keys.map((key) => curr[key]);
    acc += values.join(',');
    acc += '\n';
    return acc;
  }, csv);
};

export const exportCsvFile = (fileName: string, csvData: string): void => {
  // @ts-ignore
  if (window.navigator.msSaveOrOpenBlob) {
    const blob = new Blob([csvData]);
    // @ts-ignore
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const charBom = '\uFEFF';
    const encodedData = encodeURIComponent(csvData);
    const content =
      'data:text/' + 'csv' + ';charset=utf-8,' + charBom + encodedData;
    console.log('content', content);
    console.log('fileName', fileName);
    const link = document.createElement('a');
    link.setAttribute('href', content);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  }
};

export const exportDataToCsv = (
  fileName: string,
  data: Record<string, any>[]
): void => {
  const dataToCsv: string = toCsv(data);
  exportCsvFile(fileName, dataToCsv);
};
